import React, { useEffect, useState } from 'react';
import { MapPin, RefreshCw } from 'lucide-react';
import { BoholMap } from '../components/shared/BoholMap';
import { mapsAPI } from '../services/api';

export function Maps() {
  const [catalog, setCatalog] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const loadCatalog = async () => {
      try {
        setIsLoading(true);
        const response = await mapsAPI.getCatalog();
        if (isMounted) {
          setCatalog(Array.isArray(response.data) ? response.data : []);
          setError('');
        }
      } catch (loadError) {
        if (isMounted) {
          setCatalog([]);
          setError(loadError.message || 'Failed to load map catalog. Showing the built-in fallback.');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadCatalog();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      <div className="mx-auto max-w-7xl px-4 pt-6 sm:px-6 lg:px-8">
        <div className="mb-4 rounded-3xl border border-amber-100 bg-white/90 px-5 py-4 shadow-sm backdrop-blur">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-amber-700">
                <MapPin className="h-4 w-4" />
                User Map View
              </div>
              <h1 className="mt-2 text-xl font-bold text-slate-900">Maps</h1>
              <p className="mt-1 text-sm text-slate-600">
                Read-only map viewer. All map tabs load their images from the database while titles and descriptions stay static.
              </p>
            </div>
            {isLoading && (
              <div className="inline-flex items-center gap-2 rounded-full bg-amber-50 px-4 py-2 text-sm text-amber-800">
                <RefreshCw className="h-4 w-4 animate-spin" />
                Loading maps
              </div>
            )}
          </div>
          {error && (
            <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
              {error}
            </div>
          )}
        </div>
      </div>

      <BoholMap catalog={catalog} />
    </div>
  );
}

export default Maps;
